var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBookmarksDoubleFill = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.83333V4.16667C12.5 3.24619 11.7538 2.5 10.8334 2.5H5.00004C4.07957 2.5 3.33337 3.24619 3.33337 4.16667V13.3689C3.33337 13.663 3.48841 13.9354 3.74132 14.0855C3.99423 14.2356 4.30755 14.2413 4.56576 14.1005L7.49994 12.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 7.49999V16.6658C7.50028 16.96 7.65558 17.2323 7.90865 17.3823C8.16172 17.5323 8.47511 17.5379 8.73333 17.3969L12.0835 15.5696C12.0835 15.5696 13.7214 16.4631 15.4337 17.397C15.6919 17.5379 16.0052 17.5323 16.2582 17.3823C16.5112 17.2322 16.6664 16.96 16.6667 16.6658V7.49999C16.6667 6.57952 15.9205 5.83333 15 5.83333H9.16667C8.24619 5.83333 7.5 6.57952 7.5 7.49999Z",
    fill: "currentColor",
    fillOpacity: 0.2,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBookmarksDoubleFill);
export default ForwardRef;